import React from "react";
import { Select } from "@my-scoot/component-library-legacy";
import classnames from "classnames";

import { is_empty } from "utils/validations";
import useStyles from "./styles";

import {
  EmptyOfferings,
  Offering,
  OfferingDesctiption,
  OfferingFooter,
} from "./HelperComponents";

const OfferingSelect = ({
  loading,
  allowCreateOffering = false,
  showStatus,
  lastElementRef,
  classes: propClasses,
  EmptyOfferings: EmptyOfferingsProp = EmptyOfferings,
  emptyText,
  mobileModalTitle,
  emptyMobileModalTitle = "No live offerings",
  hideEmptyCreateOfferingBtn = false,
  showSelectAll = false,
  headerComponent,
  ...restProps
}) => {
  const {
    multiple,
    placeholder,
    options,
    route,
    selectedOfferingType,
    selectedOfferingTypeIsRequired,
    onCreateOfferingClick,
    customDescription,
  } = restProps;
  const classes = useStyles();

  const getHeaderComponent = () => {
    if (headerComponent) {
      return headerComponent;
    }

    if (is_empty(options) && !loading) {
      return (
        <EmptyOfferingsProp
          emptyText={emptyText}
          route={route}
          selectedOfferingType={selectedOfferingType}
          selectedOfferingTypeIsRequired={selectedOfferingTypeIsRequired}
          onCreateOfferingClick={onCreateOfferingClick}
          hideEmptyCreateOfferingBtn={hideEmptyCreateOfferingBtn}
        />
      );
    }

    return null;
  };

  return (
    <Select
      // Dev Comment: Verify selectedOption exists along with selectedValue before rendering description component
      // to avoid rendering an empty/undefined card when option is not found in list options.
      renderSelectedValue={
        multiple
          ? null
          : ({ selectedValue, selectedOption }) =>
              selectedValue && selectedOption ? (
                customDescription ? (
                  customDescription
                ) : (
                  <OfferingDesctiption {...selectedOption} isCondensed />
                )
              ) : (
                placeholder
              )
      }
      headerComponent={getHeaderComponent()}
      renderOption={(renderProps) => (
        <Offering
          key={renderProps?.option?.uuid}
          showCheckbox={multiple}
          showStatus={showStatus}
          lastElementRef={lastElementRef}
          {...renderProps}
        />
      )}
      mobileModalTitle={
        is_empty(options) && !loading ? emptyMobileModalTitle : mobileModalTitle
      }
      footerComponent={
        <OfferingFooter
          isLoading={loading}
          allowCreateOffering={allowCreateOffering && !is_empty(options)}
          route={route}
          selectedOfferingType={selectedOfferingType}
          selectedOfferingTypeIsRequired={selectedOfferingTypeIsRequired}
          onCreateOfferingClick={onCreateOfferingClick}
        />
      }
      classes={{
        popoverPaper: classes.scroll,
        contentWrap: classnames(
          classes.scroll,
          allowCreateOffering && classes.contentMaxHeight
        ),
        ...propClasses,
      }}
      {...restProps}
      showSelectAll={showSelectAll}
    />
  );
};

export default OfferingSelect;
